/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaProfileItem/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaProfileItem({
  children,
  viewPath = "/DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/TysiaProfileItem",
  size,
  label,
  value
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 text={label}
 weight="semibold"
 marginRight={dtSpaceS}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 text={!value ? "-" : value}
/>
{children}
</React.Fragment>)
}